import { Outlet, ScrollRestoration } from "react-router";

/**
 * Root layout component that wraps all routes
 * Provides ScrollRestoration for automatic scroll position management
 */
const RootLayout = () => {
  return (
    <>
      <ScrollRestoration />
      <Outlet />
    </>
  );
};

export default RootLayout;
